/**
 * Trạng thái tại màn hình Kiểm tra dự toán -> Cần kiểm tra
 */
export default {
    /**
     * Chưa kiểm tra
     */
    NotCheck: 1,
    /**
     * Đang kiểm tra
     */
    Checking: 2,
    /**
     * Cấp dưới yêu cầu thu hồi
     */
    RequestRevoke: 3,

    /**
     * đang xử lý
     */
    ProcessReturn: 4,
    /**
    * đang xử lý hoàn thành
    */
    ProcessComplete: 5,
    /**
     * Gửi trả không thành công
     */
    FailReturn: 6,
    /**
    * Hoàn thành không thành công
    */
     FailComplete: 7,
}